import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'kp-accordion-group',
  templateUrl: './accordion-group.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionGroupComponent implements OnInit, AfterViewInit {
  @Input() id: string; // Needs [] on variable in parent component in order to properly binds
  @Input() initialStateOpen = true; // defaults to open

  @Output() didChange = new EventEmitter<boolean>();

  isOpen = false;
  bodyOpenHeight = 0;
  isAnimating = false;

  @ViewChild('input', { static: false }) inputCheckbox: ElementRef;
  @ViewChild('collapsibleBody', { static: false }) collapsibleBody: ElementRef;

  ngOnInit() {
    this.isOpen = this.initialStateOpen;
  }

  ngAfterViewInit() {
    if (!this.isOpen && this.collapsibleBody) {
      this.collapsibleBody.nativeElement.style.height = '0px';
    }
    setTimeout(() => {
      this.bodyOpenHeight = this.collapsibleBody?.nativeElement?.scrollHeight || 0;
      this._updateAccordion(this.isOpen);
    }, 400);
  }

  accordionClick(isChecked: boolean) {
    this._updateAccordion(isChecked);
    this.didChange.emit(isChecked);

    // blur and focus checkbox in order to update voiceover text if in use
    this.isAnimating = true;
    this.inputCheckbox.nativeElement.blur();
    setTimeout(() => {
      this.inputCheckbox.nativeElement.focus();
      this.isAnimating = false;
    }, 400);
  }

  private _updateAccordion(isChecked: boolean) {
    this.isOpen = isChecked;
    if (this.collapsibleBody) {
      this.collapsibleBody.nativeElement.style.height = isChecked ? `${this.bodyOpenHeight}px` : '0px';
    }
  }
}
